import { render, staticRenderFns } from "./shipment_tracking_new.vue?vue&type=template&id=63e2da92&scoped=true"
import script from "./shipment_tracking_new.vue?vue&type=script&lang=js"
export * from "./shipment_tracking_new.vue?vue&type=script&lang=js"
import style0 from "./shipment_tracking_new.vue?vue&type=style&index=0&id=63e2da92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2da92",
  null
  
)

export default component.exports